import { render, staticRenderFns } from "./MerchantQrCode.vue?vue&type=template&id=529fc7e8&scoped=true"
import script from "./MerchantQrCode.vue?vue&type=script&lang=js"
export * from "./MerchantQrCode.vue?vue&type=script&lang=js"
import style0 from "./MerchantQrCode.vue?vue&type=style&index=0&id=529fc7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529fc7e8",
  null
  
)

export default component.exports